import { api } from 'services/api';
import { type SegmentedStatsData, type Stats, type StatsData } from 'types';

interface StatsParams {
  id: string;
  from: string;
  to: string;
  range: string;
  isDevice: boolean;
  segments?: string[];
}

interface SegmentedStatsParams extends Omit<StatsParams, 'isDevice'> {
  segments: string[];
}

export const statsApi = api
  .enhanceEndpoints({
    addTagTypes: ['Stats', 'SegmentedStats']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getStats: build.query<StatsData[], StatsParams>({
        query: ({ isDevice, id, from, to, range }) => ({
          url: isDevice ? `/device/${id}/sales/stats` : `/${id}/sales/stats`,
          method: 'GET',
          params: {
            props: 31,
            per: range,
            from,
            to
          }
        }),
        transformResponse: (res: Record<string, Stats>) =>
          Object.keys(res)
            .map((date) => parseInt(date, 10))
            .sort()
            .map((date) => {
              const dateData = res[date];
              return {
                date,
                Osmosis: dateData.Litres - (dateData.MineralLitres ?? 0),
                ...dateData
              };
            }),
        providesTags: (_res, _err, params) => [
          {
            type: 'Stats',
            id: params.id
          }
        ]
      }),
      getSegementedStats: build.query<
        SegmentedStatsData[],
        SegmentedStatsParams
      >({
        query: ({ id, from, to, range, segments }) => ({
          url: `/${id}/sales/stats/query`,
          method: 'post',
          data: {
            Ids: segments,
            From: from,
            To: to,
            Per: range,
            Types: 31
          }
        }),
        providesTags: (_res, _err, params) => [
          {
            type: 'SegmentedStats',
            id: params.id + Array.from(params.segments).sort().join(',')
          }
        ],
        transformResponse: (res: Record<string, Record<string, Stats>>) =>
          Object.keys(res).flatMap((id) => {
            const devicesData = res[id];
            return Object.keys(devicesData)
              .map((date) => parseInt(date, 10))
              .sort()
              .map((date) => {
                const dateData = devicesData[date];
                return {
                  deviceId: id,
                  date,
                  Osmosis: dateData.Litres - (dateData.MineralLitres ?? 0),
                  ...dateData
                };
              });
          })
      })
    })
  });
